/**
 * Fetch data from API and return the response as JSON
 *
 * @param {string} endPoint - The endpoint of the API
 * @param {object} [body=null] - The body of the request
 * @param {string} [method='GET'] - The method of the request
 * @return {Promise<Object>} The response data as JSON
 */
export const getApiData = async ( endPoint, body = null, method = 'GET' ) => {
    const baseURL   = (<any>window).ssb.cdn_url;
    const URL       = baseURL + endPoint;

    const response = await fetch( URL, {
        method: method,
        body: body,
        headers: {
            'Content-Type': 'application/json'
        }
    } );

    return await response.json();
}

/**
 * Tries to fetch a given URL. If it fails, it will silently ignore the error.
 *
 * @param {string} url - The URL to fetch
 */
export const tryCatchAndFetchUrl = ( url: string ): void => {
    try {
        fetch( url );
    } catch ( error ) {
        console.error( 'Error: ', error );
    }
}

export const writeLogForShareableLink = ( message, response, base64Data ) => {
    const windowGlobal = ( <any>window );
    const url = windowGlobal.ssb.ajax_url;
    const type = 'POST';
    const action = 'write_log_for_share_link';
    const dataType = 'json';
    const modelUrl = window.location.href;
    response = response ? JSON.stringify( response ) : '';
    const data = { action, message, response, base64Data, modelUrl };
    jQuery.ajax( { url, type, dataType, data } );
}
